import moment from "moment-timezone";
import colors from "src/utils/colors";
import { dateFormatMed } from "src/utils/constants";
import { EmailRegistrations } from "types/email-registrations";

export interface EmailTemplateProps {
  logo?: string;
  subhead?: string;
  content?: string;
  registrations?: EmailRegistrations[];
  organizationUrl?: string;
  organizationName?: string;
  move?: EmailTemplateMove;
}

export interface EmailTemplateMove {
  participantName: string;
  participantMeta: string;
  from: EmailRegistrations;
  to: EmailRegistrations;
}

export function renderRegistration(r: EmailRegistrations) {
  // console.log("r", r);
  let icon = "triangle-exclamation--yellow.png";
  let statusLabel = r.status;

  if (r.status === "Enrolled" || r.status === "Active") {
    if (r.finalDate) {
      icon = "bolt-lightning--red.png";
      statusLabel = `Pending cancellation • ${moment(r.finalDate).format(
        dateFormatMed
      )}`;
    } else {
      icon = "bolt-lightning--green.png";
    }
  } else if (r.status === "Waitlist") {
    icon = "triangle-exclamation--blue.png";
  } else if (r.status === "Canceled") {
    icon = "ban--gray.png";
  }

  const iconUrl = `${
    process.env.NODE_ENV === "development"
      ? "https://app.local.localhost:3000"
      : "https://app-dev.captyn.com"
  }/img/email/${icon}`;

  return (
    <tr key={r.url}>
      <td style={{ padding: r.status ? "0 0 16px 0" : 0 }}>
        <div
          style={{
            background: "#fff",
            border: r.status ? "1px solid #ddd" : undefined,
            borderRadius: "12px",
            padding: r.status ? "16px" : 0,
            overflow: "hidden",
          }}
        >
          <a
            style={{
              textDecoration: "none",
              display: "block",
              color: "#333",
            }}
            href={r.url}
          >
            {r.private && (
              <div
                style={{
                  background: "#aaa",
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "12px",
                  margin: "-16px -16px 16px -16px",
                  padding: "5px 0",
                }}
              >
                Private Lesson Series
              </div>
            )}

            {r.membership && (
              <div
                style={{
                  background: "#007CC7",
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "12px",
                  margin: "-16px -16px 16px -16px",
                  padding: "5px 0",
                }}
              >
                {r.type}
              </div>
            )}

            {r.status && (
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                <img
                  src={iconUrl}
                  alt="Icon"
                  width="16"
                  style={{
                    verticalAlign: "middle",
                  }}
                />{" "}
                <strong>{statusLabel}</strong>
              </p>
            )}

            {r.roster?.map((rr, i) => {
              return (
                <h3 key={i} style={{ margin: "0 0 5px 0" }}>
                  {rr.name}{" "}
                  {rr.age && (
                    <span
                      style={{
                        color: "#999",
                        fontWeight: "normal",
                        fontSize: "14px",
                      }}
                    >
                      {rr.age}, {rr.gender}
                    </span>
                  )}
                </h3>
              );
            })}

            {r.department && (
              <h5
                style={{
                  color: "#999",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  margin: "0px",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                {r.department}{" "}
                {r.tags?.length > 0 && (
                  <>
                    {r.tags?.map((t, i) => {
                      return (
                        <span
                          key={i}
                          style={{
                            display: "inline-block",
                            color: "#999",
                            background: "#e6e6e6",
                            fontSize: "12px",
                            padding: ".25rem .5rem",
                            borderRadius: "3px",
                            lineHeight: "1",
                            margin: ".5rem .5rem .5rem 0",
                          }}
                        >
                          {t}
                        </span>
                      );
                    })}
                  </>
                )}
              </h5>
            )}

            {r.program && (
              <h4
                style={{
                  margin: "0 0 5px 0",
                }}
              >
                <strong>{r.program}</strong>
              </h4>
            )}

            {r.title && (
              <h4
                style={{
                  fontWeight: "normal",
                  margin: 0,
                }}
              >
                {r.title}
              </h4>
            )}

            {r.description && <p>{r.description}</p>}

            {r.expirationTitle && (
              <>
                <h5
                  style={{
                    color: "#999",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    margin: 0,
                  }}
                >
                  {r.expirationTitle}
                </h5>
                <p>{r.expirationDescription}</p>
              </>
            )}

            {r.private && (
              <>
                <p
                  style={{
                    marginTop: "0",
                    marginBottom: 0,
                  }}
                >
                  {r.instructor} • {r.lessons} lessons • {r.duration} minutes
                  each
                </p>
                <p
                  style={{
                    color: "#999",
                    fontSize: "14px",
                    marginBottom: "0",
                    marginTop: 0,
                  }}
                >
                  {r.scheduledThrough}
                </p>

                {r.remainingLessons && (
                  <p style={{ color: "#999", fontSize: "14px", marginTop: 0 }}>
                    {r.remainingLessons} lessons remaining to schedule
                  </p>
                )}

                {r.ages && (
                  <p
                    style={{
                      color: "#999",
                      fontSize: "14px",
                      marginTop: 0,
                    }}
                  >
                    {r.ages}
                  </p>
                )}
              </>
            )}

            {/* {r.offeringStatus && (
              <div
                style={{
                  color: r.offeringStatusColor,
                  textTransform: "uppercase",
                  border: `1px solid ${r.offeringStatusColor}`,
                  display: "inline-block",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "5px 5px 3px 5px",
                  lineHeight: 1,
                  marginBottom: "1rem",
                }}
              >
                {r.offeringStatus}
              </div>
            )} */}

            {r.classDates && (
              <div>
                {Object.keys(r.classDates)
                  .filter((k) => r.classDates[k])
                  .map((k, i) => {
                    if (k === "startDate" || k === "endDate") {
                      return <strong key={i}>{r.classDates[k]} </strong>;
                    }

                    return <span key={i}>{r.classDates[k] + " "}</span>;
                  })}
              </div>
            )}

            {r.classTimes?.map((ct, i) => {
              return (
                <div key={i}>
                  {ct.date && (
                    <p style={{ margin: 0 }}>
                      <strong>{ct.date}</strong>{" "}
                      {ct.startTime && (
                        <>
                          {ct.startTime}
                          {ct.endTime && `–${ct.endTime}`}
                        </>
                      )}
                    </p>
                  )}

                  {!ct.date && (
                    <p style={{ margin: 0 }}>
                      <strong>{ct.day}</strong> {ct.startTime}
                      {ct.endTime && `–${ct.endTime}`}
                    </p>
                  )}

                  <p
                    style={{
                      color: "#999",
                      fontSize: "14px",
                      marginTop: "0",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {ct.instructor}
                    {ct.location && ct.instructor && ` • `}
                    {ct.location}
                    {ct.zone && ` • ${ct.zone}`}
                  </p>
                </div>
              );
            })}

            {/* {r.finalDate && (
              <p
                style={{
                  color: "#d0021b",
                  fontSize: "14px",
                  marginTop: 0,
                }}
              >
                Final date of enrollment set for {r.finalDate}
              </p>
            )} */}
          </a>

          {r.locations?.length > 0 && (
            <hr
              style={{
                width: "10%",
                border: "none",
                borderTop: "1px solid #ddd",
                margin: "1.25rem 0",
              }}
            />
          )}

          {r.locations?.map((l, i) => {
            return (
              <p
                key={i}
                style={{
                  marginTop: 0,
                }}
              >
                <strong
                  style={{
                    color: "#999",
                    textTransform: "uppercase",
                    fontSize: "13px",
                    letterSpacing: "1px",
                  }}
                >
                  {l.name}
                </strong>
                {l.address && (
                  <>
                    <br />
                    {l.address.trim() && (
                      <>
                        {l.address}
                        <br />
                      </>
                    )}
                    {l.city}, {l.state} {l.zip}{" "}
                    {l.mapUrl && <a href={`${l.mapUrl}`}>Map</a>}
                  </>
                )}
              </p>
            );
          })}

          {r.contact && (
            <p>
              <strong
                style={{
                  color: "#999",
                  textTransform: "uppercase",
                  fontSize: "13px",
                  letterSpacing: "1px",
                }}
              >
                Contact Information
              </strong>
              <br />
              {r.contact.name}
              <br />
              <a href={`mailto:${r.contact.email}`}>{r.contact.email}</a>
              <br />
              <a href={`tel:${r.contact.phone}`}>{r.contact.phone}</a>
            </p>
          )}
        </div>
      </td>
    </tr>
  );
}

export function renderMove(move: EmailTemplateMove) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "12px",
        padding: "16px",
        overflow: "hidden",
      }}
    >
      <div style={{ marginBottom: 10 }}>
        <img
          width={15}
          src="https://api.captyn.com/s3/move-to.png"
          alt="Move"
          style={{
            marginRight: 5,
            marginTop: -1,
          }}
        />{" "}
        Registration Moved
      </div>

      <div style={{ marginBottom: 20 }}>
        <strong>{move.participantName}</strong>
        <div
          style={{
            color: colors.empty,
            fontSize: 14,
          }}
        >
          {move.participantMeta}
        </div>
      </div>

      <div style={{ marginBottom: 10 }}>
        <img
          width={15}
          src="https://api.captyn.com/s3/move-from.png"
          alt="Move"
          style={{
            marginRight: 5,
            marginTop: -1,
          }}
        />{" "}
        From
      </div>

      <div
        style={{
          borderLeft: `2px solid ${colors.error}`,
          padding: "0 0 0 10px",
          marginBottom: 20,
        }}
      >
        <table>
          <tbody>{move.from && renderRegistration(move.from)}</tbody>
        </table>
      </div>

      <div style={{ marginBottom: 10 }}>
        <img
          width={15}
          src="https://api.captyn.com/s3/move-to.png"
          alt="Move"
          style={{
            marginRight: 5,
            marginTop: -1,
          }}
        />{" "}
        To
      </div>

      <div
        style={{
          borderLeft: `2px solid ${colors.success}`,
          padding: "0 0 0 10px",
          marginBottom: 10,
        }}
      >
        <table>
          <tbody>{move.to && renderRegistration(move.to)}</tbody>
        </table>
      </div>
    </div>
  );
}

export function EmailTemplate(props: EmailTemplateProps) {
  // console.log("props.registrations", props.registrations);

  return (
    <table
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      style={{ width: "100%" }}
    >
      <tbody>
        <tr>
          <td style={{ background: "#fff" }}>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{ width: "100%", maxWidth: "640px", margin: "auto" }}
            >
              <tbody>
                {props.logo && (
                  <tr>
                    <td style={{ background: "#fff", padding: "30px 0" }}>
                      <img
                        className="logo"
                        src={props.logo}
                        alt={props.organizationName}
                        width="180"
                        style={{ width: "180px", borderRadius: "6px" }}
                      />
                    </td>
                  </tr>
                )}

                {!props.logo && (
                  <tr>
                    <td style={{ background: "#fff", padding: "30px 0" }}>
                      <img
                        className="logo"
                        src="https://api.captyn.com/s3/captyn-logo.png"
                        width="180"
                        style={{ width: "180px" }}
                        alt="Captyn Logo"
                      />
                    </td>
                  </tr>
                )}

                <tr>
                  <td
                    style={{ padding: "0 0 30px 0" }}
                    dangerouslySetInnerHTML={{ __html: props.content }}
                  />
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        {props.registrations?.length > 0 && (
          <tr>
            <td
              style={{
                background: "#f2f2f2",
                borderTop: "1px solid #ddd",
                paddingTop: "16px",
                paddingBottom: "16px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <table
                cellPadding="0"
                cellSpacing="0"
                style={{ width: "100%", maxWidth: "640px", margin: "auto" }}
              >
                <tbody>
                  {props.registrations.map((r) => renderRegistration(r))}
                </tbody>
              </table>
            </td>
          </tr>
        )}

        {props.move && (
          <tr>
            <td
              style={{
                background: "#f2f2f2",
                borderTop: "1px solid #ddd",
                paddingTop: "16px",
                paddingBottom: "16px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <table
                cellPadding="0"
                cellSpacing="0"
                style={{ width: "100%", maxWidth: "640px", margin: "auto" }}
              >
                <tbody>
                  <tr>
                    <td style={{ padding: 0 }}>{renderMove(props.move)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        )}

        <tr>
          <td style={{ background: "#fafafa" }}>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{ width: "100%", maxWidth: "640px", margin: "auto" }}
            >
              <tbody>
                <tr>
                  <td style={{ color: "#333", padding: "25px 0 0 0" }}>
                    <a href={`https://${props.organizationUrl}`}>Sign in</a> to
                    manage from any device.
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td style={{ background: "#fafafa", textAlign: "left" }}>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{ width: "100%", maxWidth: "640px", margin: "auto" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      color: "#9b9b9b",
                      padding: "5px 0 5px 0",
                      fontWeight: "bold",
                    }}
                  >
                    Driven by{" "}
                    <a href="https://captyn.com">
                      <img
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                          width: "90px",
                        }}
                        width="90"
                        src="https://app.captyn.com/img/captyn-logo-gray.png"
                        alt="Captyn"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      color: "#9b9b9b",
                      padding: "0 0 20px 0",
                      fontSize: 10,
                    }}
                  >
                    <a href="%unsubscribe_url%">unsubscribe</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export const emailFoot = `
</body>
</html>
`;

export const emailHead = `
<!doctype html>
<html>

<head>
  <meta charset="utf-8" />
</head>

<body>
  <link rel="stylesheet" href="https://use.typekit.net/dlm1ocu.css" />

  <style>
    html,
    body {
      background: #fafafa;
      font-family: "Soleil", sans-serif;
      font-size: 15px;
      line-height: 1.5;
      color: #000;
      margin: 0;
      padding: 0;
    }

    h1,
    h2,
    h3,
    h4,
    p {
      margin-top: 0;
      color: #000;
    }

    table {
      width: 100%;
      line-height: inherit;
      text-align: left;
      border-collapse: collapse;
    }

    table td {
      padding: 0 1rem;
    }

    .meta {
      color: #9b9b9b;
    }

    hr {
      border: none;
      border-top: 1px solid #ddd;
      margin: 1.25rem 0;
    }

    a {
      color: #2970ff;
      text-decoration: none;
    }

    ul, ol {
      padding: 0 0 0 2rem;
      margin: 0 0 1rem 0;
    }

    ul li {
      list-style-type: disc;
    }

    ol li {
      list-style-type: decimal;
    }
  </style>
`;
